export const ADD_NOTE = "ADD_NOTE"
export const REMOVE_NOTE = "REMOVE_NOTE"
export const CLEAR_NOTE = "CLEAR_NOTE"
export const SET_NOTE = "SET_NOTE"

export const SET_ORDERS = "SET_ORDERS"


export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";